import React from 'react';

import { SignUpContext, SignUpContextProps } from '../provider/SignUpContext';

export const useSignUp = (): SignUpContextProps => {
  const context = React.useContext(SignUpContext);

  if (!context) {
    throw new Error(
      'SignUpProvider context is undefined, please verify you are calling useSignUp() as child of a <SignUpProvider> component.'
    );
  }

  return context;
};
